<template>
  <router-link v-if="page === 'propagation'" :to="`/domains/${urlDomain}/dns-propagation/a/`" :title="`DNS propagation for ${domain}`"
  ><slot>{{ domain }}</slot></router-link>
  <router-link v-else-if="page === 'dns-records'" :to="`/domains/${urlDomain}/dns-records/`" :title="`DNS records for ${domain}`"
  ><slot>{{ domain }}</slot></router-link>
  <router-link v-else-if="page === 'webservers'" :to="`/domains/${urlDomain}/webservers/`" :title="`IP addresses for ${domain}`"
  ><slot>{{ domain }}</slot></router-link>
  <router-link v-else-if="page === 'SPF'" :to="`/domains/${urlDomain}/email/spf/`" :title="`SPF record for ${domain}`"
  ><slot>{{ domain }}</slot></router-link>
  <router-link v-else :to="`/domains/${urlDomain}/dns-records/${urlRecordType}/`" :title="`${plural} for ${domain}`"
  ><slot>{{ domain }}</slot></router-link>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { withoutTrailingDot } from '@/common/domainName';
import { getRecordType, RecordTypesUnion } from '@/common/recordTypes';

const props = defineProps({
  domain: {
    type: String,
    required: true,
  },
  page: {
    type: String as PropType<RecordTypesUnion | 'propagation' | 'webservers' | 'dns-records' | 'SPF'>,
    default: 'dns-records',
  },
});

const urlDomain = computed(() => withoutTrailingDot(props.domain));
const urlRecordType = computed(() => props.page?.toLowerCase());
const plural = computed(() => {
  if (!['propagation', 'webservers', 'dns-records'].includes(props.page)) {
    return getRecordType(props.page).plural;
  }
  return '';
});
</script>
